import React, { useContext, useEffect, useState } from 'react'
import P from '../../assets/python.jpg'
import M from '../../assets/makeup.jpg'
import W from '../../assets/web.jpg'
import CourseCard, { CourseCardSkeleton } from '../../Components/CourseCard'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { appContext } from '../../Context/appProvider'
import { useQuery } from 'react-query'
import axios from 'axios'
import { baseUrl, path } from '../../constants'
import Preview from '../Landing/Components/Preview'
import { api } from '../../api'
import Select from 'react-select'
import { settingsContext } from '../../Context/settingsProvider'

const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      borderColor: "#6622cf", 
      color: "#6622cf",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#6622cf" : isFocused ? "#6622cf60" : "white",
      color: isSelected ? "white" : "#6622cf",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#6622cf", 
    }),
  };

export default function Category() {
    const {categories} = useContext(appContext)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedSubCategory, setSelectedSubCategory] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const {maincat, subcat} = useParams()
    const [courses, setCourses] = useState([])
    const [selectedCourse, setSelectedCourse] = useState()
    const navigate = useNavigate()

    const compareByName = (a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
      
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
    };

    const filterCourses = (data, type) => {
        if(type == 'subcat') return data.courses || []
        else {
            let _courses = []
            data?.subcategories?.forEach(sub => {
                _courses.push(...sub.courses)
            })
            return _courses
        }
    }

    const fetchCourses = (_maincat, _subcat) => {
        setIsLoading(true)
        api(path.courses + '?maincat=' + _maincat + '&subcat=' + _subcat)
        .then(response => {
            setIsLoading(false)
            setCourses(response.data.courses)
        })
    }

    useEffect(() => {
        fetchCourses(maincat || '', subcat || '')
    }, [maincat, subcat])

    const options = categories?.sort(compareByName)?.map(cat => ({label: cat.name, value: cat.name}))

    // console.log(data?.data)
  return (
    <div className='w-full h-full flex flex-col bg-[#f2f2f2] pt-[60px] overflow-x-hidden'>
        <Header withLogo />
        <div className='flex flex-col gap-4 flex-1'>
            {/* <p className='text-black font-bold tracking-wide text-[13px] uppercase max-md:hidden pt-5 pl-2'>Categories</p>
            <hr className='text-[#00000050] max-md:hidden' /> */}
            <div className='flex-1 flex gap-14'>
                <div className='flex  gap-4 fixed z-[9999] ml-2 max-md:ml-0 items-center bg-[#f2f2f2] w-full pl-5'>
                    <Select
                    styles={customStyles}
                    value={options?.find(o => o.value == maincat.replace(/-/g, ' '))}
                    className='w-[350px] whitespace-nowrap'
                    onChange={e => navigate('/category/' + e.value.replace(/ /g, '-'))}
                    placeholder='Select Category'
                        options={options}
                    />
                    <CourseChooser
                        categories={categories?.sort(compareByName)}
                        selectedCategory={selectedCategory}
                        setSelectedCategory={setSelectedCategory}
                        selectedSubCategory={selectedSubCategory}
                        subcat={subcat}
                        maincat={maincat}
                        setSelectedSubCategory={setSelectedSubCategory}
                    />
                    {/* {categories?.sort(compareByName)?.map(category => (
                        <Link className={`text-black text-[16px] ${category.name.replace(/ /g, '-') == maincat ? 'border-l-4 border-l-main' : ''} pl-2`} to={'/category/' + category.name.replace(/ /g, '-')}>{category.name}</Link>
                    ))} */}
                </div>
                <div className='flex flex-1 flex-col pt-[10px]'>
                    <Courses isLoading={isLoading} courses={courses} setSelectedCourse={setSelectedCourse} />
                </div>
            </div>
        </div>
        <Footer />
        {selectedCourse && <Preview setSelectedCourse={setSelectedCourse} selectedCourse={selectedCourse} /> }
    </div>
  )
}

export function CourseChooser({ categories, selectedCategory, subcat, maincat }){
    const {t} = useContext(settingsContext)
    return (
        <div className='flex gap-5 items-center z-[9999]  w-full p-5  overflow-y-auto'>
            <Link className={`text-sm py-2 px-4 rounded-sm font-bold outline-none border-none ${('all' == subcat || !subcat) ? 'bg-main text-white' : 'bg-[#f0f0f0] text-[#404040]'}`} to={'/category/' + maincat}>{t('ALL')}</Link>
            {(categories?.find(cat => cat.name.replace(/ /g, '-') == maincat))?.subcategories?.map(sub => (
                <Link className={`text-sm p-2 rounded-sm font-bold whitespace-nowrap outline-none border-[transparent] border-[1px] hover:border-[#00000080] box-border ${sub.name.replace(/ /g, '-') == subcat ? 'bg-main text-white' : 'bg-[#f0f0f0] text-[#404040]'} pl-2`} to={'/category/' + maincat + '/' + sub.name.replace(/ /g, '-')}>{sub.name}</Link>
            ))}
        </div>
    )
}

const courses = [
    {name: 'Python for begginers', instructor: 'Fuad hy', rating: {value: 4.5, count: 400}, price: 700, image: P},
    {name: 'Makeup tutorial', instructor: 'Fuad hy', rating: {value: 3.5, count: 400}, price: 700, image: M}
]

function Courses({courses, isLoading, setSelectedCourse}){
    return (
        <div className='flex-1 grid max-md:mt-[50px] grid-cols-4 max-md:grid-cols-1 gap-x-4 gap-y-4 p-5 pt-[100px] pr-2 max-md:justify-items-center overflow-x-auto'>
            { isLoading ? new Array(4).fill(0).map(course => (
                <CourseCardSkeleton />
            )) : courses.map(course => (
                <CourseCard course={course} self={false} setSelectedCourse={setSelectedCourse} />
            ))}
        </div>
    )
}